import config from 'Config'; /* eslint-disable-line */
import store from '../../';

export default async (data) => {
  const authUser = store.getState().user;

  try {
    const response = await fetch(`${config.apiUrl}/companies`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: authUser.access_token,
        'grifin-user-key': authUser.publicKey,
      },
      body: JSON.stringify(data),
    });

    const isJson = response.headers.get('content-type')?.includes('application/json');

    const body = isJson ? await response.json() : await response.text();

    if (!response.ok) {
      return {
        success: false,
        error: {
          status: response.status,
          message: typeof body === 'string' ? body : 'An unknown error occurred.',
        },
      };
    }

    return { success: true, data: body };
  } catch (err) {
    return {
      success: false,
      error: {
        message: err?.message || 'A network error occurred.',
      },
    };
  }
};
